import React from 'react';
import './QuizAnswer.css'
import { SlideAnswerData } from '../../../models/Quiz';

interface QuizAnswerProps {
    answer: SlideAnswerData
    selected: boolean
    handleSelect: (id: number) => void;
}

function QuizAnswer({answer, selected, handleSelect}: QuizAnswerProps) {

  return (
    <div className={`quiz-answer ${selected && "answer-selected"}`} onClick={()=> {handleSelect(answer.answerId)}}>
        {answer.answerText}
    </div>
  );
};

export default QuizAnswer;